import {useEffect, useMemo} from 'react';
import {useJobContext} from 'contexts';
import {PartialJob} from 'shared/types/PartialJob';
import {useFetchBenchesData} from 'components/customer/BTM/helper/useFetchBenchesData';
import {
    useLazyGetExtraVariationsQuery,
    useLazyGetJobCabinetVariationDetailsQuery,
} from 'components/customer/Job/store/jobApi';

interface JobVariationsProps {
    noVariations: boolean;
    notRemovableExtraVariatons: boolean;
    extraVariation: boolean;
}

export const useJobVariations = (): JobVariationsProps => {
    const {job, room} = useJobContext() as PartialJob;
    const {benches} = useFetchBenchesData();
    const [getExtraVariations, {data: extraVariationList}] =
        useLazyGetExtraVariationsQuery();
    const [getJobCabinetVariationCount, {data: variationDetails}] =
        useLazyGetJobCabinetVariationDetailsQuery();

    useEffect(() => {
        if (job && job.id) {
            void getExtraVariations({jobId: job.id}, true);
            void getJobCabinetVariationCount({jobId: job.id}, true);
        }
    }, [job]);

    const variations = useMemo(() => {
        const allCabinetsCommentsEmpty =
            variationDetails && variationDetails.length == 0;

        const allBenchtopsCommentsEmpty =
            benches?.every((bench) => !bench.isOld && bench.comment === '') ??
            true;

        const nonRemovableExtraVariation =
            extraVariationList?.every((item) => !item.removable) ?? true;

        return {
            notRemovable: nonRemovableExtraVariation,
            noVariations: allCabinetsCommentsEmpty && allBenchtopsCommentsEmpty,
            extraVariation: extraVariationList?.length > 0,
        };
    }, [variationDetails, benches, extraVariationList, room]);

    return {
        noVariations: variations.noVariations,
        notRemovableExtraVariatons: variations.notRemovable,
        extraVariation: variations.extraVariation,
    };
};
